import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { IData } from '../../helpers/interface';
// import { useEffect, useState } from 'react';
// import axios from 'axios';

interface IProps {
  moduleData: IData;
  isView: boolean;
  handleHolidayCheckBox: any;
  handelDeleteRows: any;
  department: string;
}

const TController = ({
  moduleData,
  isView,
  handleHolidayCheckBox,
  handelDeleteRows,
  department,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            handleHolidayCheckBox,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handelDeleteRows,
            department,
          }}
        />
        <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
